<script setup lang="ts">
import Modal from '@/components/main/modal.vue'
import Navbar from '@/components/main/navbar.vue'
import AppFooter from '@/components/main/footer.vue'
import { localstore, session } from '@/utils/localstorage'
import { currency_formats, InitCheckout } from '@/utils/checkout'
import {config} from "@/conf";

// get url arguments
const args = new URLSearchParams(window.location.search)

// get gclid and save if defined
const gclid = args.get('gclid')
if (gclid) {
  session.set('gclid', 'gclid' + gclid)
} else {

  // get gbraid and save if defined
  const gbraid = args.get('gbraid')
  if (gbraid) {
    session.set('gclid', 'gbraid' + gbraid)
  } else {

    // get wbraid and save if defined
    const wbraid = args.get('wbraid')
    if (wbraid) {
      session.set('gclid', 'wbraid' + wbraid)
    }
  }
}

// get currency from args
let currency = args.get('c')
// get currency from local storage if args is undefined
if (!currency) {
  currency = localstore.get('currency') || 'eur'
}
// force lowercase
currency = currency!.toLowerCase()
// if currency not supported, set to euro
if (!currency_formats[currency]) {
  currency = 'eur'
}
// save to local storage
localstore.set('currency', currency)

if (config.lang.iso === 'ar' || config.lang.iso === 'he') {
  document.body.classList.add('rtl')
}

// init checkout
InitCheckout()

</script>

<template>
  <navbar/>
  <router-view/>
  <app-footer/>
  <modal/>
</template>
